import modal from './modal-bottom';

const footer = document.querySelector('.m-footer');
const btnNewsletter = footer?.querySelector('.btn-newsletter');

btnNewsletter?.addEventListener('click', (e) => {
  e.preventDefault();
  // the panel closes on a click outside it, and this link is outside: without this the
  // panel would shut instead of coming back to the newsletter (modules/modal-bottom.ts)
  e.stopPropagation();
  modal.showModal();
});